import { splitCareFocusSelection } from "../../constants/childProfileOptions";
import { getPhoneHref } from "../../utils/contactPhone";

const asArray = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  return value ? [value] : [];
};

const getItemLabel = (item) => {
  if (!item) return "";
  if (typeof item === "string") return item.trim();
  return String(item.label || item.name || item.title || item.value || item.code || "").trim();
};

const uniqueLabels = (labels = []) => {
  const seen = new Set();
  return labels.filter((label) => {
    const key = String(label || "").trim().toLowerCase();
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

const formatList = (items = [], limit = 2) => {
  const labels = uniqueLabels(
    asArray(items)
      .map(getItemLabel)
      .filter(Boolean)
      .filter((label) => label.toLowerCase() !== "none")
  );

  if (!labels.length) return [];
  return labels.slice(0, limit);
};

const getCareFocusItems = (child = {}) => (
  asArray(child.careContext?.careFocus).length
    ? child.careContext.careFocus
    : child.conditions || child.concerns || child.selectedConditions || []
);

export const getChildCareFocusLabel = (child = {}) => {
  if (child.isDraftProfile) return "Not saved yet";

  const { primaryFocus } = splitCareFocusSelection(getCareFocusItems(child));
  return getItemLabel(primaryFocus) || "Care profile";
};

export const getChildDiagnosisSummary = (child = {}) => {
  const diagnosis = getItemLabel(child.diagnosis);
  const { primaryFocus, additionalSupports } = splitCareFocusSelection(getCareFocusItems(child));
  const focusLabel = getItemLabel(primaryFocus);
  const supportLabels = formatList(additionalSupports, 2);
  const parts = uniqueLabels([diagnosis, focusLabel, ...supportLabels].filter(Boolean));

  return parts.length ? parts.join(" · ") : "";
};

export const getChildAllergySummary = (child = {}) => (
  formatList(child.medicalProfile?.foodAllergies, 3).join(", ")
);

export const getChildEmergencyContactSummary = (child = {}) => {
  const lines = String(child.supportProfile?.emergencyContacts || child.supportGoals?.emergencyContacts || "")
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  const firstLine = lines[0] || "";
  if (!firstLine) return null;

  const phoneHref = getPhoneHref(firstLine);
  const phoneText = phoneHref ? firstLine.match(/(\+?\d[\d\s().-]{6,}\d)/)?.[1]?.trim() || "" : "";
  const nameText = firstLine
    .replace(phoneText, "")
    .replace(/[:\-|]+$/g, "")
    .trim();

  return {
    name: nameText || firstLine,
    phone: phoneText,
    phoneHref,
  };
};
